import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useMapStore = defineStore('map', () => {
  const center = ref<[number, number]>([47.5, 19.0])
  const zoom = ref(6)
  const isDarkMode = ref(false)

  const mapSettings = computed(() => ({
    center: center.value,
    zoom: zoom.value,
    darkMode: isDarkMode.value
  }))

  function updateCenter(newCenter: [number, number]) {
    center.value = newCenter
  }

  function updateZoom(newZoom: number) {
    zoom.value = newZoom
  }

  function setDarkMode(enabled: boolean) {
    isDarkMode.value = enabled
  }

  return {
    center,
    zoom,
    isDarkMode,
    mapSettings,
    updateCenter,
    updateZoom,
    setDarkMode
  }
})